import { flow, get, mapValues, toLower, find, curry } from 'lodash/fp';

export default curry((optionName, item) => flow(
  get('itemProduct.choices'),
  mapValues(choice => ({
    ...choice,
    optionName: toLower(choice.optionName),
  })),
  find({ optionName: toLower(optionName) }),
)(item));
